// extracted by mini-css-extract-plugin
module.exports = {"select":"Select_select__26JP9","left":"Select_left__pbdoC","label":"Select_label__G_XuT","container":"Select_container___t3fn","combobox":"Select_combobox__Tcb62"};